export const Scripts: ModdedBattleScriptsData = {
	inherit: 'gen6',
};
